module.exports = __webpack_public_path__ + "static/media/icon-header-default.7cb2ec22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Header/assets/icon-header-default.svg
// module id = 1507
// module chunks = 193